<script setup lang="ts">
import Hotjar from '@hotjar/browser'
import { onMounted } from 'vue'
import { useProfilerStore } from '~/stores/profiler'
import { configureZodErrorMap } from '~/utils'

const runtimeConfig = useRuntimeConfig()

const isProd = import.meta.env.PROD
const { isSwitching } = storeToRefs(useProfilerStore())
const { t } = useI18n()
const toast = useToast()
const alertBuilder = useAlertBuilder()
onMounted(() => {
  Hotjar.init(runtimeConfig.public.HOTJAR.SITE_ID, runtimeConfig.public.HOTJAR.VERSION, {
    debug: false,
  })

  if (!Hotjar.isReady())
    console.debug('Hotjar error')

  configureZodErrorMap(t)
})

onErrorCaptured((error) => {
  console.error(error)
  toast.add(
    alertBuilder.error({
      title: t('generics.error-title'),
      description: t('generics.error.try-again'),
    }),
  )

  return false
})
</script>

<template>
  <UApp :tooltip="{ delayDuration: 0 }">
    <div v-if="!isProd" class="fixed bottom-2 right-10 bg-default z-99 rounded-xl">
      <UColorModeButton />
    </div>
    <NuxtPage :class="isSwitching ? 'blur-xl' : ''" />
  </UApp>
</template>
